import { Container } from '@pixi/react'
import { BuyBonus } from './BuyBonus'
import { ExtraBet } from './ExtraBet'

export const BuyBonusBar = () => {
  return (
    <Container
      name="BuyBonusBar"
      y={490}
      width={1030}
    >
      <BuyBonus />
      <ExtraBet />
    </Container>
  )
}
